/* Képes méretválasztó a Teeinblue „Méret” opciójához.
   Minden mérethez egy arányos keretrajzot teszünk; a keret anyaga a kiválasztott
   színből / a termék nevéből jön (fekete, fehér, tölgy, dió, vászon). */
(function () {
  if (window.__teeSizeVisual) return;
  window.__teeSizeVisual = true;

  var BOX_W = 66, BOX_H = 68;
  var DIM = /(\d+(?:[.,]\d+)?)\s*[x×]\s*(\d+(?:[.,]\d+)?)/i;

  var MATERIALS = [
    ['canvas', /vászon|canvas/],
    ['walnut', /dió|walnut/],
    ['oak', /tölgy|natúr|natur|oak|fa keret/],
    ['white', /fehér|white/],
    ['black', /fekete|black/]
  ];

  function material(form) {
    var texts = [];
    form.querySelectorAll('.tee-option:not(.tee-option--size) .tee-radio').forEach(function (r) {
      var input = r.querySelector('input');
      if (r.classList.contains('active') || (input && input.checked)) texts.push((input && input.value) || r.textContent);
    });
    var title = document.querySelector('.product__title');
    texts.push(title ? title.textContent : document.title);
    var hay = texts.join(' ').toLowerCase();
    for (var i = 0; i < MATERIALS.length; i++) if (MATERIALS[i][1].test(hay)) return MATERIALS[i][0];
    return 'black';
  }

  function parse(radio) {
    var input = radio.querySelector('input');
    var text = (input && input.value) || radio.textContent;
    var m = text.match(DIM);
    if (!m) return null;
    var name = text.split(/\s[-–]\s/)[0].trim();
    var extra = (text.match(/\(([^)]+)\)/) || [])[1];
    if (name === text.trim()) name = '';
    return {
      w: parseFloat(m[1].replace(',', '.')),
      h: parseFloat(m[2].replace(',', '.')),
      name: name,
      dims: m[1] + '×' + m[2] + ' cm' + (extra ? ' · ' + extra : '')
    };
  }

  function setup() {
    document.querySelectorAll('.tee-option--size').forEach(function (opt) {
      var radios = Array.prototype.slice.call(opt.querySelectorAll('.tee-radio'));
      var data = radios.map(parse);
      if (data.length < 2 || data.some(function (d) { return !d; })) return;
      var big = data.reduce(function (a, d) { return d.w * d.h > a.w * a.h ? d : a; });
      var scale = Math.min(BOX_W / big.w, BOX_H / big.h);
      opt.classList.add('tee-size-visual');
      opt.style.setProperty('--size-count', radios.length);
      radios.forEach(function (radio, i) {
        var label = radio.querySelector('.tee-radio-label');
        if (!label || label.querySelector('.tee-size-art')) return;
        var d = data[i];
        var art = document.createElement('span');
        art.className = 'tee-size-art';
        art.setAttribute('aria-hidden', 'true');
        var frame = document.createElement('span');
        /* Valós méretarány: minden keret ugyanazzal a szorzóval kicsinyítve */
        var fw = Math.round(d.w * scale), fh = Math.round(d.h * scale);
        frame.className = 'tee-size-frame';
        frame.style.width = fw + 'px';
        frame.style.height = fh + 'px';
        art.appendChild(frame);
        var text = document.createElement('span');
        text.className = 'tee-size-text';
        text.setAttribute('aria-hidden', 'true');
        text.innerHTML = (d.name ? '<b class="tee-size-name"></b>' : '') + '<span class="tee-size-dim"></span>';
        if (d.name) text.querySelector('.tee-size-name').textContent = d.name;
        text.querySelector('.tee-size-dim').textContent = d.dims;
        label.insertBefore(art, label.firstChild);
        label.appendChild(text);
      });
      var form = opt.closest('form, .tee-customization-wrapper') || document;
      var mat = material(form);
      if (opt.dataset.frame !== mat) opt.dataset.frame = mat;
    });
  }

  var timer;
  function later() { clearTimeout(timer); timer = setTimeout(setup, 80); }
  new MutationObserver(later).observe(document.documentElement, { subtree: true, childList: true });
  document.addEventListener('change', later);
  document.addEventListener('click', later);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
  else setup();
})();
